import { useEffect, useRef, useState } from "react";
import { MobileView, isIOS, isMobile } from "react-device-detect";
import Sheet from "react-modal-sheet";
import FaClose from "../SVG/Fontawesome/FaClose";
import Portal from "@/layouts/Portal";
import AllenDNLogoSingle from "../SVG/AllenDNLogoSingle";
import { getDownloadAppBsLS, removeDownloadAppBsLS, setDownloadAppBsLS } from "@/utils";
import dynamic from "next/dynamic";
import ComputerScreen from "../SVG/ComputerScreen";

// these icons are positioned absolute won't increase height or width after dynamically loaded.
const LiveClass = dynamic(() => import("../SVG/LiveClass"));
const Recording = dynamic(() => import("../SVG/Recording"));
const Practice = dynamic(() => import("../SVG/Practice"));

const DownloadAppBS = (props: {
  classType?: string | number;
}) => {
  const initScrollY = useRef<number>(0);
  const [isOpen, setOpen] = useState<boolean>(false);

  const closeBottomSheet = () => {
    window.dataLayer?.push({
      event: "downloadapp-close"
    });
    setOpen(false);
  }
  
  const openBottomSheet = () => {
    const scrolled = Math.abs(window.scrollY - initScrollY.current);
    if (scrolled < 200) return;
    window.removeEventListener("scroll", openBottomSheet);
    setOpen(true);
  }

  const handleOpenClick = () => {
    window.dataLayer?.push({
      event: "downloadapp-open"
    });
    // year set to 9999 to avoid showing the bottom sheet again
    setDownloadAppBsLS(new Date("9999").getTime().toString());
    window.open(isIOS ? "https://apps.apple.com/in/app/allen-neet-jee-class-6-12/id6449251524?utm_source=Doubtnut&utm_medium=doubtnut_web&utm_campaign=doubtnut_bottom_sheet" : "https://allen.onelink.me/90jx/qst10ifh");
    setOpen(false);
  }

  const onTapBackDrop = (e: any) => {
    e.stopPropagation();
  }

  useEffect(() => {
    const previousTime = getDownloadAppBsLS();
    const diffInHours = Math.floor((new Date().getTime() - Number(previousTime)) / 1000 / 60 / 60);
    // 12 hours cooldown
    const showDownloadBs = diffInHours >= 12 || !previousTime;

    if (!showDownloadBs || !isMobile) return;
    setDownloadAppBsLS(new Date().getTime().toString());
    window?.dataLayer?.push({
      event: "downloadapp-show"
    });
    initScrollY.current = window.scrollY;
    window.addEventListener("scroll", openBottomSheet);

    return () => {
      window.removeEventListener("scroll", openBottomSheet);
    };
  }, [])

  return (
    <Sheet isOpen={isOpen} onClose={closeBottomSheet} detent="content-height" mountPoint={global?.window?.document?.getElementById("base-layout") as any} disableDrag>
      <MobileView>
        <Portal>
          <Sheet.Container className="!bg-secondary !rounded-t-2xl">
            <button id="downloadapp-bottomsheet-close" name="login-bottomsheet-close" className="absolute p-2 right-4 -top-12 bg-white rounded-full  text-black flex justify-center items-center" onClick={closeBottomSheet}>
              <FaClose className="w-4 h-4 text-inherit" />
            </button>
            <Sheet.Content className="p-4">
              <div>
                <AllenDNLogoSingle />
              </div>

              <div>
                <h2 className="mt-4 font-bold text-lg w-3/4"> 
                  Unlock FREE Revision Crash Course for {typeof props.classType === "number" ? `${props.classType}th` : props.classType}
                </h2>

                <p className="text-xs text-text-inactive mt-2">For limited time period</p>
              </div>

              <div className="flex flex-col card !bg-body-bg gap-6 rounded-2xl mt-6 font-semibold text-sm py-4 pl-8 pr-14 ml-8">
                <div className="absolute right-0 top-20">
                  <ComputerScreen />
                </div>

                <div className="flex items-center"> 
                  <LiveClass className="absolute left-4" />
                  <div>
                    <span className="text-text-success">FREE</span> Live revision classes
                  </div>
                </div>  

                <div className="flex items-center">
                  <Recording className="absolute left-6" />

                  <div>
                    <span className="text-text-success">FREE</span>  Recordings & questions of all topics
                  </div>
                </div>

                <div className="flex items-center">
                  <Practice className="absolute left-4" />

                  <div>
                    <span className="text-text-success">FREE</span> Mock tests 
                  </div>
                </div>
              </div>

              <div>
                <button onClick={handleOpenClick} className="mt-6 btn btn-primary w-full">
                  Download ALLEN app
                </button>
              </div>
            </Sheet.Content>
          </Sheet.Container>
        </Portal>
        <Sheet.Backdrop className="!bg-black/70" onTap={onTapBackDrop} />
      </MobileView>
    </Sheet>
  );
}

export default DownloadAppBS;